export default __webpack_public_path__ + "static/media/mobile-menu-background.aec7f268.jpg";